import {managers, modules, services} from "../../engines/gameEngine";
import {TT} from "../../engines/services/i18nService";
import {I18nLanguageEnum} from "../../engines/services/i18nContent/i18nInterface";

const {ccclass, property} = cc._decorator;

//Privacy policy
export const URL_PRIVACY_POLICY = 'https://res.wqop2018.com//app/common/privacy.html?company=长沙零动科技有限公司';
export const URL_USER_AGREEMENT = 'https://res.wqop2018.com//app/common/agreement.html?app_name=知识就是力量游戏软件';

@ccclass
export default class gameSetting extends cc.Component {

    // LIFE-CYCLE CALLBACKS:
    @property({type: [cc.SpriteFrame], displayName: '音效开关精灵帧'})
    spfArySound: cc.SpriteFrame[] = [];
    @property({type: [cc.SpriteFrame], displayName: '振动开关精灵帧'})
    spfAryVibrate: cc.SpriteFrame[] = [];
    @property(cc.Sprite)
    spSound: cc.Sprite = null;
    @property(cc.Sprite)
    spVibrate: cc.Sprite = null;
    @property(cc.Label)
    lbSelectLanguage: cc.Label = null;

    protected onLoad() {

    }

    protected start() {
        modules().uiControlModule.showHideDialogAnimation(this.node.getChildByName('center'), true);
        this.initView();
    }

    protected initView() {
        TT(this.node);
        this.updateLanguageSelected();
    }

    protected onBtnSelectLanguage() {
        const languages = ['简体中文', '繁體中文', 'English'];
        const e = services().i18nSrv.getI18nSetting();
        modules().uiControlModule.showSelectBox('语言', '请选择语言', languages).then(index => {
            if (index < 0) {
                return;
            } else {
                if (index != e) {
                    services().i18nSrv.setI18nSetting(index);
                    modules().uiControlModule.showDialogBox('设置成功', '需要重启后生效', true, isOk => {
                        if (isOk) {
                            cc.game.restart();
                        }
                    }, null, '立即重启', '然后重启');
                    this.updateLanguageSelected();
                }
            }
        });
    }

    protected updateLanguageSelected() {
        const e = services().i18nSrv.getI18nSetting();
        switch (e) {
            case I18nLanguageEnum.ZH_CN: {
                this.lbSelectLanguage.string = TT('简体中文');
                break;
            }
            case I18nLanguageEnum.ZH_TC: {
                this.lbSelectLanguage.string = TT('繁体中文');
                break;
            }
            case I18nLanguageEnum.ENGLISH: {
                this.lbSelectLanguage.string = TT('English');
                break;
            }
        }
    }

    protected onBtnClose() {
        managers().soundMgr.playSound('anNiu').then();
        managers().soundMgr.playVibrate();
        modules().uiControlModule.showHideDialogAnimation(this.node.getChildByName('center'), false, () => {
            this.node.destroy();
        });
    }

    protected onBtnPrivacy() {
        cc.sys.openURL(URL_PRIVACY_POLICY);
    }

    protected onBtnUserAgreement() {
        cc.sys.openURL(URL_USER_AGREEMENT);
    }

    protected onBtnSwitchSet(event: any, custom: string) {
        switch (custom) {
            case 'sound': {
                managers().soundMgr.setSoundEnabled(!managers().soundMgr.isSoundEnabled());
                break;
            }
            case 'vibrate': {
                managers().soundMgr.setVibrateEnabled(!managers().soundMgr.isVibrateEnabled());
                break;
            }
        }
        managers().soundMgr.playSound('anNiu').then();
        managers().soundMgr.playVibrate();
    }

    update(dt) {
        this.spSound.spriteFrame = this.spfArySound[Number(managers().soundMgr.isSoundEnabled())];
        this.spVibrate.spriteFrame = this.spfAryVibrate[Number(managers().soundMgr.isVibrateEnabled())];
    }
}
